/**
 * localStorage 键名常量
 * 集中管理所有本地存储键，避免硬编码字符串分散在项目中
 */

export const STORAGE_KEYS = {
    /** 用户认证 token */
    TOKEN: 'token',
    /** 用户信息 */
    USER_INFO: 'userInfo',
    /** 菜单列表 */
    MENU_LIST: 'menuList',
    /** 首页路径 */
    HOME: 'home',
    /** 店铺列表 */
    SHOPS: 'shops',
    /** 当前选中店铺 IDs */
    CURRENT_SHOP_IDS: 'currentShopIds',
    /** 构建版本号 */
    VERSION: 'version',
    /** 最近访问记录 */
    RECENT_VISITS: 'recentVisits',
    /** 表格尺寸配置 */
    TABLE_SIZE: 'TpTableSize'
} as const;

/**
 * 动态生成表格配置存储键
 * @param name 表格名称
 */
export const getTableConfigKey = (name: string) => `${name}_config`;

/**
 * 动态生成导出选择存储键
 * @param type 导出类型
 */
export const getExportSelectionKey = (type: string) => `export${type}Selection`;

/**
 * 动态生成输入历史存储键
 * @param field 字段名
 */
export const getInputHistoryKey = (field: string) => `inputHistoryData_${field}`;
